<template>
  <fragment>
    <b-row
      no-gutters
      class="job-offer-details-card-header v2_font_size_18 font-weight-bold text-center mt-2 mb-2"
    >
      <b-col cols="4" offset="4"> My Ask</b-col>
      <b-col cols="4">Offer</b-col>
    </b-row>
    <div class="job-offer-terms-container p-1 pb-2 mb-2">
      <b-row>
        <b-col>
          <span class="font-weight-bold font_size_1000rem"> Core Terms </span>
        </b-col>
      </b-row>
      <b-row
        no-gutters
        v-for="jobQuestion in requiredJobQuestionsWithResponses"
        :key="jobQuestion.id"
        class="mt-3"
      >
        <b-col cols="4" class="font-weight-bold">
          {{ jobQuestion.label }}
        </b-col>
        <b-col cols="4">
          <template
            v-if="
              Array.isArray(jobQuestion.responses) &&
              jobQuestion.responses.length > 0
            "
          >
            <div
              v-for="(value, i) in jobQuestion.responses"
              :key="'jp_rv_' + jobQuestion.id + '_' + i"
              class="text-break text-center d-flex justify-content-center"
              v-html="value"
            />
          </template>
          <div
            v-else
            class="text-break text-center d-flex justify-content-center"
          >
            &mdash;
          </div>
        </b-col>
        <b-col cols="4">
          <template
            v-if="
              jobOffer.jobQuestionResponses &&
              jobOffer.jobQuestionResponses[jobQuestion.id]
            "
          >
            <div
              v-for="(value, i) in getJobOfferJobQuestionResponseValue(
                jobQuestion,
                jobOffer.jobQuestionResponses[jobQuestion.id],
                jobProfile
              )"
              :key="'jp_rv_' + jobQuestion.id + '_' + i"
              class="text-break text-center d-flex justify-content-center"
              v-html="value"
            />
          </template>
          <div
            v-else-if="jobQuestion.type === 'GEOGRAPHY'"
            class="text-break text-center d-flex justify-content-center"
          >
            <long-string-with-tooltip
              :text="jobOffer.cbsa_name"
              :length="18"
              :delay="400"
              target-key="cbsa-name"
            />
          </div>
          <div
            v-else
            class="text-break text-center d-flex justify-content-center"
          >
            &mdash;
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      class="job-offer-terms-container p-1 pb-2"
      v-if="
        optionalJobQuestionsWithResponses &&
        optionalJobQuestionsWithResponses.length
      "
    >
      <b-row class="mt-2 mb-2">
        <b-col>
          <span class="font-weight-bold font_size_1000rem">
            Additional Terms
          </span>
        </b-col>
      </b-row>
      <b-row
        no-gutters
        v-for="jobQuestion in optionalJobQuestionsWithResponses"
        :key="jobQuestion.id"
        class="mt-3"
      >
        <b-col cols="4" class="font-weight-bold text-center">
          {{ jobQuestion.label }}
        </b-col>
        <b-col cols="4">
          <template
            v-if="
              Array.isArray(jobQuestion.responses) &&
              jobQuestion.responses.length > 0
            "
          >
            <div
              v-for="(value, i) in jobQuestion.responses"
              :key="'jp_rv_' + jobQuestion.id + '_' + i"
              class="text-break text-center d-flex justify-content-center"
              v-html="value"
            />
          </template>
          <div
            v-else
            class="text-break text-center d-flex justify-content-center"
          >
            &mdash;
          </div>
        </b-col>
        <b-col cols="4">
          <template
            v-if="
              jobOffer.jobQuestionResponses &&
              jobOffer.jobQuestionResponses[jobQuestion.id]
            "
          >
            <div
              v-for="(value, i) in getJobOfferJobQuestionResponseValue(
                jobQuestion,
                jobOffer.jobQuestionResponses[jobQuestion.id],
                jobProfile
              )"
              :key="'jp_rv_' + jobQuestion.id + '_' + i"
              class="text-break text-center d-flex justify-content-center"
              v-html="value"
            />
          </template>
          <div
            v-else
            class="text-break text-center d-flex justify-content-center"
          >
            &mdash;
          </div>
        </b-col>
      </b-row>
    </div>
  </fragment>
</template>

<script>
import {
  createJobQuestionsSorter,
  getJobQuestionResponseValues,
} from '@/helpers/jobQuestionsHelper';
import { getJobOfferJobQuestionResponseValue } from '@/helpers/recruiter/jobOfferHelper';
import LongStringWithTooltip from '@/components/ui-elements/LongStringWithTooltip';
import { JOB_QUESTION_TYPES } from '@/store';

const jobQuestionsSorter = createJobQuestionsSorter('display_order');

export default {
  name: 'JobProfileJobOfferComparison',
  props: {
    jobOffer: Object,
    jobProfile: Object,
    jobQuestions: Array,
  },
  components: {
    LongStringWithTooltip,
  },
  computed: {
    requiredJobQuestionsWithResponses: function () {
      return this.requiredQuestions.reduce((acc, activeJobQuestion) => {
        const profileJobQuestion = this.jobProfile.jobQuestions.find(
          ({ id }) => parseInt(id) === parseInt(activeJobQuestion.id)
        );
        const responses = profileJobQuestion
          ? getJobQuestionResponseValues(profileJobQuestion)
          : [];
        if (
          (Array.isArray(responses) && responses.length > 0) ||
          (this.jobOffer.jobQuestionResponses &&
            this.jobOffer.jobQuestionResponses[activeJobQuestion.id])
        ) {
          acc.push({ ...(profileJobQuestion || activeJobQuestion), responses });
        }
        return acc;
      }, []);
    },
    optionalJobQuestionsWithResponses: function () {
      return this.optionalQuestions.reduce((acc, activeJobQuestion) => {
        const profileJobQuestion = this.jobProfile.jobQuestions.find(
          ({ id }) => parseInt(id) === parseInt(activeJobQuestion.id)
        );
        const responses = profileJobQuestion
          ? getJobQuestionResponseValues(profileJobQuestion)
          : [];
        if (
          (Array.isArray(responses) && responses.length > 0) ||
          (this.jobOffer.jobQuestionResponses &&
            this.jobOffer.jobQuestionResponses[activeJobQuestion.id])
        ) {
          acc.push({ ...(profileJobQuestion || activeJobQuestion), responses });
        }
        return acc;
      }, []);
    },
    mappedJobQuestions: function () {
      const mappedQuestions = this.jobQuestions.map((activeJobQuestion) => {
        const profileJobQuestion = this.jobProfile.jobQuestions.find(
          ({ id }) => parseInt(id) === parseInt(activeJobQuestion.id)
        );
        return profileJobQuestion ? profileJobQuestion : activeJobQuestion;
      });
      return [
        ...mappedQuestions,
        this.jobProfile.jobQuestions.find(
          ({ type }) => type === JOB_QUESTION_TYPES.GEOGRAPHY
        ),
      ];
    },
    requiredQuestions: function () {
      return this.mappedJobQuestions
        .filter((q) => q.required || q.type === JOB_QUESTION_TYPES.GEOGRAPHY)
        .sort(jobQuestionsSorter);
    },
    optionalQuestions: function () {
      return this.mappedJobQuestions
        .filter((q) => !q.required && q.type !== JOB_QUESTION_TYPES.GEOGRAPHY)
        .sort(jobQuestionsSorter);
    },
  },
  methods: {
    getJobOfferJobQuestionResponseValue: function (
      jobQuestion,
      jobOfferJobQuestionResponse
    ) {
      return getJobOfferJobQuestionResponseValue(
        jobQuestion,
        jobOfferJobQuestionResponse
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins';
.job-offer-details-card-header {
  @media (max-width: $tablet-portrait - 1px) {
    font-size: 12px;
  }
  @media (max-width: $laptop - 1px) {
    font-size: 14px;
  }
}
.job-offer-terms-container {
  border: 1px solid lightgray;
  border-radius: 0;
}
</style>
